import {Enum} from '@/utils/Enum.js'

export default {
    fudaiEnum: new Enum().add('zhufudai','祝福袋','ZHUFU').add('qiankundai','乾坤袋','QIANKUN')
}
